import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";

export const Nav = styled.nav`
  margin: 0px;
  background: #fff;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 1rem;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;
/* position: sticky; */

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
  color: #11373e;
  justify-self: flex-start;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  font-size: 2rem;
  font-weight: 500;
  letter-spacing: 1.4px;
  text-decoration: none;
  font-family: "Poppins";
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #000;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled.div`
  color: #000;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 1.4rem;
  font-family: "Helvetica Neue";
  padding: 0rem 0rem 0rem 1rem;
  height: 100%;
  cursor: pointer;

  &.active {
    border-bottom: 3px solid #01bf71;
  }
`;
